import React, { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '@/contexts/PermissionContext';

interface RoleProtectedRouteProps {
  children: ReactElement;
}

/**
 * @deprecated This component is deprecated. Use PermissionGuard with specific permissions instead.
 * Example: <PermissionGuard permission="manage_settings">{children}</PermissionGuard>
 */
const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children }) => {
  const { hasPermission, loading } = usePermissions();
  const location = useLocation();

  const hasAdminAccess = hasPermission('settings.admin') || hasPermission('manage_roles') || hasPermission('manage_users');

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasAdminAccess) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default RoleProtectedRoute; 